import * as React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {fetchTaxonomy} from '../utilities';
import ServiceIndex from './service-index';
import ExpertIndex from './expert-index';
import NotFound from './not-found';

export default function SectionFactory({
  match,
}: RouteComponentProps<{
  serviceSlug1: string;
  serviceSlug2?: string;
  serviceSlug3?: string;
}>) {
  const {serviceSlug1, serviceSlug2, serviceSlug3} = match.params;
  const taxonomy = fetchTaxonomy();
  const taxonomyNode = taxonomy.getTaxonomyNode(
    serviceSlug3 || serviceSlug2 || serviceSlug1
  );

  if (taxonomyNode === null) return <NotFound />;

  return taxonomy.isSelectable(taxonomyNode.service) ? (
    <ExpertIndex taxonomyNode={taxonomyNode} />
  ) : (
    <ServiceIndex taxonomyNode={taxonomyNode} />
  );
}
